import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import ChannelIcon from "../ChannelIcon";

/**
 * #4271 — escolha das conexões que um usuário pode ver.
 *
 * Espelha o `QueueSelect`, no outro eixo de visibilidade.
 *
 * A lista NÃO pode sair do `WhatsAppsContext`: ele carrega `GET /whatsapp`,
 * que é o caminho de OPERAÇÃO e vem recortado pelo acesso de quem está
 * logado. Um admin restrito não conseguiria conceder a conexão que ele mesmo
 * não vê, e um admin restrito a nenhuma não conseguiria nem se liberar —
 * softlock. Aqui se pede o escopo de administração, que devolve todas as
 * conexões da empresa e só o necessário para marcar a caixa (sem token nem
 * credenciais).
 */
const useStyles = makeStyles(() => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
}));

const ConnectionSelect = ({ selectedConnectionIds = [], onChange, title }) => {
  const classes = useStyles();
  const [conexoes, setConexoes] = useState([]);

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        const { data } = await api.get("/whatsapp", {
          params: { scope: "management" },
        });
        if (ativo) setConexoes(Array.isArray(data) ? data : []);
      } catch (err) {
        toastError(err);
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  return (
    <div style={{ marginTop: 6 }}>
      <FormControl fullWidth margin="dense" variant="outlined">
        <InputLabel>
          {title || i18n.t("connectionSelect.inputLabel")}
        </InputLabel>
        <Select
          multiple
          labelWidth={60}
          value={selectedConnectionIds}
          onChange={(e) => onChange(e.target.value)}
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            getContentAnchorEl: null,
          }}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected?.length > 0 &&
                selected.map((id) => {
                  const conexao = conexoes.find((c) => c.id === id);
                  // Conexão excluída depois de concedida: o vínculo some do
                  // banco por CASCADE, mas o formulário pode estar aberto com
                  // o id antigo. Mostra o id em vez de sumir em silêncio.
                  return (
                    <Chip
                      key={id}
                      variant="outlined"
                      label={conexao ? conexao.name : `#${id}`}
                      className={classes.chip}
                    />
                  );
                })}
            </div>
          )}
        >
          {conexoes.map((conexao) => (
            <MenuItem key={conexao.id} value={conexao.id}>
              <span className={classes.item}>
                <ChannelIcon channel={conexao.channel} />
                {conexao.name}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ConnectionSelect;
